// extracted by mini-css-extract-plugin
export var base = "_35-0";
export var updateBanner = "_35-1";